module.exports = "static/assets/7c67e2601425784a243cd7e0f15c50a3.svg";